import React, { useEffect, useState } from "react";
// @ts-ignore
// @ts-ignore
// @ts-ignore
import { CircularProgress } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useAppDispatch, useAppSelector } from "../redux/hook";
import {
  getOrganizationSettings,
  setOrgaizationSettings,
} from "../utils/storage";
import { useOrganizationSettings } from "../api/hooks/organizationSettings";
// @ts-ignore
// @ts-ignore
// @ts-ignore
import { useVerifyBvn } from "../api/hooks/useAuth";
import CustomButton from "../components/customButton";
import { verifyBvn } from "../redux/verifyBvn/api";
import { extractErrors, formatLabel } from "../utils/utils";
import CustomInput from "../components/customInput";
// @ts-ignore
// @ts-ignore
// @ts-ignore
import { redirect, useLocation, useNavigate } from "react-router-dom";
import {
  useSupportedCountries,
  useSupportedCurrencies,
} from "../api/hooks/useUtilities";
import PhoneInputField from "../components/customPhoneInput";
// @ts-ignore
// @ts-ignore
// @ts-ignore
import { SuccessToast } from "../components/Toast";
import { useToast } from "../components/toastContext";
import { signupApi } from "../redux/signup/api";
import { verifyNin } from "../redux/verifyNin/api";
import { signupWithoutKycApi } from "../redux/signupWithoutKyc/api";
import { clearSignupWithoutKycResponse } from "../redux/signupWithoutKyc/signupWithoutKycSlice";
import { clearSignupResponse } from "../redux/signup/signupSlice";
import { clearVerifyBvnResponse } from "../redux/verifyBvn/verifyBvnSlice";
import { clearVerifyNinResponse } from "../redux/verifyNin/verifyNinSlice";
import Loader from "../components/loader";
import { verifyCustomApiLookup } from "../redux/verifyCustomApiLookup/api";
import LogoHeader from "../components/logoHeader";

const APPID = process.env.REACT_APP_APPID;

export default function Signup() {
  const [step, setStep] = useState("choose"); // choose | kycMethod | form
  const [registerType, setRegisterType] = useState(null); // kyc | no-kyc
  const [kycMethod, setKycMethod] = useState(""); // bvn | nin
  // @ts-ignore
  // @ts-ignore
  // @ts-ignore
  const [loading, setLoading] = useState(false);
  const [errorResponse, setErrorResponse] = useState("");
  const [signupErrors, setSignupErrors] = useState([]);
  const [successful, setSuccessful] = useState("");

  const [bvn, setBvn] = useState();
  const [nin, setNin] = useState();
  const [verifiableField, setVerifiableField] = useState({
    name: "",
    value: "",
  });
  const navigate = useNavigate();

  const [countryCode, setCountryCode] = useState("NG");
  const [selectedCountry, setSelectedCountry] = useState();

  const verifyBvnResponse = useAppSelector(
    // @ts-ignore
    (state) => state.verifyBvnSlice.response
  );
  // @ts-ignore
  const verifyBvnError = useAppSelector((state) => state.verifyBvnSlice.error);

  const verifyCustomApiLookupResponse = useAppSelector(
    // @ts-ignore
    (state) => state.verifyCustomApiLookupSlice.response
  );
  // @ts-ignore
  const verifyCustomApiLookupError = useAppSelector(
    // @ts-ignore
    (state) => state.verifyCustomApiLookupSlice.error
  );

  const verifyNinResponse = useAppSelector(
    // @ts-ignore
    (state) => state.verifyNinSlice.response
  );
  // @ts-ignore
  const verifyNinError = useAppSelector((state) => state.verifyNinSlice.error);

  const verifyBvnLoading = useAppSelector(
    // @ts-ignore
    (state) => state.verifyBvnSlice.loading
  );
  const verifyNinLoading = useAppSelector(
    // @ts-ignore
    (state) => state.verifyNinSlice.loading
  );

  // @ts-ignore
  const signupResponse = useAppSelector((state) => state.signupSlice.response);
  // @ts-ignore
  const signupError = useAppSelector((state) => state.signupSlice.error);

  // @ts-ignore
  const signupLoading = useAppSelector((state) => state.signupSlice.loading);

  // @ts-ignore
  // @ts-ignore
  const signupWithoutKycResponse = useAppSelector(
    // @ts-ignore
    (state) => state.signupWithoutKycSlice.response
  );
  // @ts-ignore
  // @ts-ignore
  const signupWithoutKycError = useAppSelector(
    // @ts-ignore
    (state) => state.signupWithoutKycSlice.error
  );

  // @ts-ignore
  // @ts-ignore
  const signupWithoutKycLoading = useAppSelector(
    // @ts-ignore
    (state) => state.signupWithoutKycSlice.loading
  );

  let organizationSettings = getOrganizationSettings();

  const [supportedCountries, setSupportedCountries] = useState([]);
  const [supportedCurrencies, setSupportedCurrencies] = useState([]);

  // @ts-ignore
  // @ts-ignore
  // @ts-ignore
  const { data: countries, isLoading: isCountriesLoading } =
    useSupportedCountries();

  // @ts-ignore
  // @ts-ignore
  // @ts-ignore
  const { data: currencies, isLoading: isCurrenciesLoading } =
    useSupportedCurrencies();

  const dispatch = useAppDispatch();

  // @ts-ignore
  // @ts-ignore
  // @ts-ignore
  const { success, error, warning, info } = useToast();

  const [verifiedLookupUsername, setVerifiedLookupUsername] = useState("");

  const location = useLocation();

  const { type } = location.state || {};

  // @ts-ignore
  // @ts-ignore
  // @ts-ignore
  const { data, isLoading } = useOrganizationSettings();

  const genderOptions = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
  ];

  const [formData, setFormData] = useState({
    id_type: "",
    id_value: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    email: "",
    username: "",
    tel_prefix: "",
    telephone: "",
    country_id: "",
    virtual_wallet_currency_code: "",
    gender: "",
    date_of_birth: "",
    physical_address: "",
    password: "",
    transaction_pin: "",
  });

  const [lockedFields, setLockedFields] = useState([]); // fields from KYC API that are

  const addField = (fieldName, initialValue = "") => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: initialValue,
    }));
  };

  const handleOnBlur = () => {
    if (verifiableField.name.length > 0) {
      setVerifiedLookupUsername("");
      // @ts-ignore
      dispatch(verifyCustomApiLookup(verifiableField.value));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (data.data.enable_customized_fields) {
      data.data.org_customized_form_fields.forEach((element) => {
        if (element.input_name == name) {
          if (name in formData) {
            console.log("we are setting");
            setFormData({ ...formData, [name]: value });
          }

          if (element.id_field_verifiable) {
            setVerifiableField({ name, value });
          }
        }
      });
    }

    if (name == "kycNumber") {
      if (kycMethod == "bvn") {
        setBvn(value);
      } else if (kycMethod == "nin") {
        setNin(value);
      }

      setFormData({ ...formData, id_type: kycMethod, id_value: value });
      return;
    } else if (name == "id_type") {
      if (kycMethod == "bvn") {
        setBvn(value);
      }
    } else if (name == "country_id") {
      if (value == "") {
        setFormData({ ...formData, country_id: undefined });
        return;
      }

      const newSelectedCountry = countries.data.find((element) => {
        return element.id == value;
      });

      setSelectedCountry(newSelectedCountry);

      setCountryCode(newSelectedCountry.code);
    }

    if (lockedFields.includes(name)) return; // prevent editing locked fields
    setFormData({ ...formData, [name]: value });
  };

  useEffect(() => {
    if (!verifyBvnResponse && !verifyNinResponse) return;

    if (verifyBvnResponse.status || verifyNinResponse.status) {
      setFormData({
        ...formData,
        first_name: verifyBvnResponse.status
          ? verifyBvnResponse.data.first_name
          : verifyNinResponse.data.first_name,
        middle_name: verifyBvnResponse.status
          ? verifyBvnResponse.data.middle_name ?? ""
          : verifyNinResponse.data.middle_name,
        last_name: verifyBvnResponse.status
          ? verifyBvnResponse.data.last_name
          : verifyNinResponse.data.last_name,

        email: verifyBvnResponse.status
          ? verifyBvnResponse.data.email ?? ""
          : verifyNinResponse.data.email ?? "",
        gender: verifyBvnResponse.status
          ? verifyBvnResponse.data.gender.toLowerCase()
          : verifyNinResponse.data.gender.toLowerCase(),
      });

      setStep("form");
    } else {
      console.log("This is error here");

      setErrorResponse(verifyBvnResponse.message);
    }
  }, [verifyBvnResponse, verifyNinResponse]);

  useEffect(() => {
    console.log(formData);
  }, [formData]);

  useEffect(() => {
    if (!verifyBvnError && !verifyNinError) return;

    console.log("This is error here");

    setErrorResponse(
      kycMethod == "bvn" ? verifyBvnError.message : verifyNinError.message
    );
  }, [verifyBvnError, verifyNinError]);

  useEffect(() => {
    if (!signupResponse) return;

    if (signupResponse.status) {
      clearAndNavigateToSuccess();
      // setSuccessful("Registration successful! Please check your email.");
    }
  }, [signupResponse]);

  useEffect(() => {
    if (!verifyCustomApiLookupResponse) return;

    if (verifyCustomApiLookupResponse.status) {
      setVerifiedLookupUsername(verifyCustomApiLookupResponse.data.full_name);
    } else {
      setVerifiedLookupUsername("");
    }
  }, [verifyCustomApiLookupResponse]);

  useEffect(() => {
    if (!signupWithoutKycResponse) return;

    if (signupWithoutKycResponse.status) {
      clearAndNavigateToSuccess();
      // setSuccessful("Registration successful! Please check your email.");
    }
  }, [signupWithoutKycResponse]);

  useEffect(() => {
    if (!signupError) return;

    if (!signupError.status) {
      const allErrors = extractErrors(signupError);

      setSignupErrors(allErrors);
      // setSuccessful("Registration successful! Please check your email.");
    }
  }, [signupError]);

  useEffect(() => {
    if (!signupWithoutKycError) return;

    if (!signupWithoutKycError.status) {
      console.log("I am here ooooo ");

      const allErrors = extractErrors(signupWithoutKycError);

      setSignupErrors(allErrors);
      // setSuccessful("Registration successful! Please check your email.");
    }
  }, [signupWithoutKycError]);

  useEffect(() => {
    if (countries) {
      let allCountries = [];
      setSupportedCountries([]);

      countries.data.forEach((country) => {
        allCountries.push({ value: country.id, label: country.name });
      });

      setSupportedCountries(allCountries);
    }
  }, [countries]);

  useEffect(() => {
    if (currencies) {
      let allCurrencies = [];
      setSupportedCurrencies([]);

      currencies.data.data.forEach((currency) => {
        allCurrencies.push({
          value: currency.code,
          label: `${currency.name} (${currency.code})`,
        });
      });

      setSupportedCurrencies(allCurrencies);
    }
  }, [currencies]);

  const clearAndNavigateToSuccess = () => {
    dispatch(clearSignupResponse());
    dispatch(clearSignupWithoutKycResponse());
    dispatch(clearVerifyBvnResponse());
    dispatch(clearVerifyNinResponse());

    navigate("signup-success");
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    dispatch(clearSignupWithoutKycResponse());
    dispatch(clearSignupResponse());
    setLoading(true);
    setErrorResponse("");
    setSuccessful("");
    setSignupErrors([]);

    if (selectedCountry) {
      // @ts-ignore
      formData.tel_prefix = selectedCountry.phone_code;
    }

    if (!formData.id_type && !formData.id_value) {
      delete formData.id_type;
      delete formData.id_value;
    }

    // ✅ Check if all fields have non-empty values
    const allFilled = Object.values(formData).every(
      (value) => value !== "" && value !== null && value !== undefined
    );

    if (!allFilled) {
      error("Please complete the form to continue");
      console.log(formData);

      return;
    }

    try {
      console.log("Submitting registration:", {
        ...formData,
        registerType,
        kycMethod,
      });

      if (!formData.id_type && !formData.id_value) {
        // @ts-ignore
        dispatch(signupWithoutKycApi(formData));
      } else if (formData) {
        // @ts-ignore
        dispatch(signupApi(formData));
      }
    } catch (err) {
      setErrorResponse("Registration failed. Try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!data) return;

    setOrgaizationSettings(data.data);

    organizationSettings = getOrganizationSettings();

    if (
      !data.data.customized_app_displayable_menu_items[
        "display-registeration-menu"
      ]
    ) {
      console.log("Display reg menu is false");
      navigate("/login");
    } else {
      if (data.data.enable_customized_fields) {
        data.data.org_customized_form_fields.forEach((element) => {
          addField(element.input_name, "");
        });
      }
    }
    console.log(data.data);
  }, [data]);

  const handleVerification = () => {
    setErrorResponse("");

    if (kycMethod == "bvn") {
      // @ts-ignore
      dispatch(verifyBvn(bvn));
    } else {
      // @ts-ignore
      dispatch(verifyNin(nin));
    }
  };

  // @ts-ignore
  // @ts-ignore
  // @ts-ignore
  const handleFetchKycData = async (method) => {
    setLoading(true);
    setErrorResponse("");
    try {
      // Simulate API response (replace with real endpoint)
      let apiData;
      if (method === "bvn") {
        apiData = {
          first_name: "John",
          middle_name: "O.",
          last_name: "Doe",
          email: "john.doe@example.com",
          date_of_birth: "1990-01-01",
          gender: "male",
        };
      } else {
        apiData = {
          first_name: "Mary",
          middle_name: "A.",
          last_name: "Smith",
          email: "mary.smith@example.com",
          date_of_birth: "1992-05-10",
          gender: "female",
        };
      }

      setFormData((prev) => ({
        ...prev,
        ...apiData,
      }));

      setLockedFields(Object.keys(apiData)); // lock fetched fields
      setStep("form");
    } catch (err) {
      setErrorResponse("Failed to fetch KYC data.");
    } finally {
      setLoading(false);
    }
  };

  const renderChooseStep = () => (
    <>
      {isLoading && <Loader size="20" />}

      {!isLoading && (
        <div className="space-y-6">
          <h2 className="text-2xl font-bold text-gray-900 text-center">
            Choose Registration Type
          </h2>
          <p className="text-gray-500 text-center">
            Select how you’d like to register
          </p>
          <div className="space-y-4 mt-6">
            {data &&
              data.data.customized_app_displayable_menu_items[
                "display-register-with-kyc"
              ] == true && (
                <button
                  onClick={() => {
                    setRegisterType("kyc");
                    setStep("kycMethod");
                  }}
                  className="w-full btn-primary py-4 text-lg font-semibold"
                >
                  Register with KYC
                </button>
              )}
            {data &&
              data.data.customized_app_displayable_menu_items[
                "display-register-with-no-kyc-option"
              ] == true && (
                <button
                  onClick={() => {
                    setRegisterType("no-kyc");
                    setStep("form");
                  }}
                  className="w-full btn-secondary py-4 text-lg font-semibold"
                >
                  Register without KYC
                </button>
              )}
          </div>
          <div className="text-sm text-gray-500">
            {"Already have an account? "}
            <a
              href="login"
              className="text-primary-600 hover:text-primary-800 font-medium transition-colors duration-200"
            >
              Login
            </a>
          </div>
        </div>
      )}
    </>
  );

  const renderKycMethodStep = () => (
    <div className="space-y-6">
      <button
        onClick={() => {
          if (type == "no_kyc") {
            navigate(-1);
          } else {
            setStep("choose");
          }
        }}
        className="flex items-center text-primary-600 hover:text-primary-800 mb-4"
      >
        <ArrowBackIcon className="mr-2" /> Back
      </button>

      <h2 className="text-2xl font-bold text-gray-900 text-center">
        Select KYC Method
      </h2>
      <select
        value={kycMethod}
        onChange={(e) => setKycMethod(e.target.value)}
        className="input-field w-full"
      >
        <option value="">-- Select --</option>
        {organizationSettings.customized_app_displayable_menu_items[
          "display-register-with-bvn-option"
        ] && <option value="bvn">Register with BVN</option>}
        {organizationSettings.customized_app_displayable_menu_items[
          "display-register-with-nin-option"
        ] && <option value="nin">Register with NIN</option>}
      </select>

      <input
        type="text"
        name="kycNumber"
        onChange={handleChange}
        required
        className="input-field pl-12"
        placeholder="Enter Number"
      />
      {errorResponse && (
        <div className="p-3 bg-red-100 border border-red-300 rounded-lg text-red-700">
          {errorResponse}
        </div>
      )}
      <CustomButton
        label={"Continue"}
        isLoading={verifyBvnLoading || verifyNinLoading}
        onPress={handleVerification}
      />

      <div className="text-sm text-gray-500">
        {"Already have an account? "}
        <a
          href="login"
          className="text-primary-600 hover:text-primary-800 font-medium transition-colors duration-200"
        >
          Login
        </a>
      </div>
    </div>
  );

  const renderFormStep = () => (
    <form onSubmit={handleRegister} className="space-y-6">
      <button
        onClick={() =>
          registerType === "kyc" ? setStep("kycMethod") : setStep("choose")
        }
        type="button"
        className="flex items-center text-primary-600 hover:text-primary-800 mb-4"
      >
        <ArrowBackIcon className="mr-2" />
        Back
      </button>

      <h2 className="text-2xl font-bold text-gray-900 text-center mb-4">
        {registerType === "kyc" ? "Register with KYC" : "Register without KYC"}
      </h2>

      <div className="grid grid-cols-1 gap-4">
        {(bvn || nin) && (
          <CustomInput
            inputType="text"
            inputName="id_value"
            label={bvn ? "BVN" : "NIN"}
            value={formData.id_value}
            onChange={handleChange}
            placeholder="First Name"
            required
            className={`input-field ${
              lockedFields.includes("first_name")
                ? "bg-gray-100 cursor-not-allowed"
                : ""
            }`}
            readOnly={bvn || nin}
          />
        )}
        <CustomInput
          inputType="text"
          inputName="first_name"
          label={formatLabel("first_name")}
          value={formData.first_name}
          onChange={handleChange}
          placeholder="First Name"
          required
          className={`input-field ${
            lockedFields.includes("first_name")
              ? "bg-gray-100 cursor-not-allowed"
              : ""
          }`}
          readOnly={bvn || nin}
        />

        <CustomInput
          inputType="text"
          inputName="middle_name"
          label={formatLabel("middle_name")}
          value={formData.middle_name}
          onChange={handleChange}
          placeholder="Middle Name"
          required
          className={`input-field ${
            lockedFields.includes("last_name")
              ? "bg-gray-100 cursor-not-allowed"
              : ""
          }`}
          readOnly={bvn || nin}
        />

        <CustomInput
          inputType="text"
          inputName="last_name"
          label={formatLabel("last_name")}
          value={formData.last_name}
          onChange={handleChange}
          placeholder="Last Name"
          required
          className={`input-field ${
            lockedFields.includes("last_name")
              ? "bg-gray-100 cursor-not-allowed"
              : ""
          }`}
          readOnly={bvn || nin}
        />

        <CustomInput
          inputType="email"
          inputName="email"
          label={formatLabel("email")}
          value={formData.email}
          onChange={handleChange}
          placeholder="Email"
          required
          className={`input-field ${
            lockedFields.includes("email")
              ? "bg-gray-100 cursor-not-allowed"
              : ""
          }`}
          readOnly={lockedFields.includes("email")}
        />

        <CustomInput
          inputType="text"
          inputName="username"
          label={formatLabel("username")}
          value={formData.username}
          onChange={handleChange}
          placeholder="Username"
          required
          className={`input-field ${
            lockedFields.includes("username")
              ? "bg-gray-100 cursor-not-allowed"
              : ""
          }`}
          readOnly={lockedFields.includes("username")}
        />

        <CustomInput
          inputType="date"
          inputName="date_of_birth"
          label={formatLabel("date_of_birth")}
          value={formData.date_of_birth}
          onChange={handleChange}
          required
          placeholder="Date of Birth"
          className={`input-field ${
            lockedFields.includes("date_of_birth")
              ? "bg-gray-100 cursor-not-allowed"
              : ""
          }`}
          readOnly={lockedFields.includes("date_of_birth")}
        />

        <CustomInput
          inputType="select"
          inputName="gender"
          label={formatLabel("gender")}
          value={formData.gender}
          onChange={handleChange}
          options={genderOptions}
          required
          placeholder="Select Gender"
          className={`input-field ${
            lockedFields.includes("gender")
              ? "bg-gray-100 cursor-not-allowed"
              : ""
          }`}
          readOnly={bvn || nin}
        />

        <CustomInput
          inputType="select"
          inputName="country_id"
          label={"Country"}
          value={formData.country_id}
          onChange={handleChange}
          required
          options={supportedCountries}
          placeholder="Select Country"
          className={`text-gray-700"`}
          // readOnly={lockedFields.includes("country_id")}
        />

        {formData.country_id && (
          <PhoneInputField
            value={formData.telephone}
            country={countryCode}
            onChange={(value) => {
              console.log(value.target.value);

              setFormData({ ...formData, telephone: value.target.value });
            }}
          />
        )}

        <CustomInput
          inputType="select"
          inputName="virtual_wallet_currency_code"
          label={"Primary Wallet Currency"}
          value={formData.virtual_wallet_currency_code}
          onChange={handleChange}
          required
          options={supportedCurrencies}
          placeholder="Select Primary Wallet Currency"
          className={`text-gray-700"`}
          // readOnly={lockedFields.includes("country_id")}
        />

        <CustomInput
          inputType="text"
          inputName="physical_address"
          label={formatLabel("physical_address")}
          value={formData.physical_address}
          onChange={handleChange}
          placeholder="Enter Physical Address"
          className={`input-field ${
            lockedFields.includes("physical_address")
              ? "bg-gray-100 cursor-not-allowed"
              : ""
          }`}
          readOnly={lockedFields.includes("physical_address")}
        />

        {data.data.enable_customized_fields && (
          <div>
            {data.data.org_customized_form_fields.map((field) => {
              // Check if field is required from validation rules
              const validationRules = JSON.parse(
                field.input_validation_rules || "[]"
              );
              const isRequired = validationRules.includes("required");

              // Handle select options (if input_type === "select")
              let options = [];
              if (field.input_options) {
                try {
                  options = JSON.parse(field.input_options).map((opt) => ({
                    label: opt.label || opt,
                    value: opt.value || opt,
                  }));
                } catch {
                  options = [];
                }
              }

              return (
                <div className="mb-6">
                  <CustomInput
                    key={field.id}
                    label={formatLabel(field.input_label)}
                    inputName={field.input_name}
                    value={formData[field.input_name]}
                    placeholder={formatLabel(field.input_placeholder || "")}
                    inputType={field.input_type}
                    options={options}
                    required={isRequired}
                    onBlur={field.id_field_verifiable ? handleOnBlur : null}
                    onChange={handleChange}
                  />
                  {field.id_field_verifiable && (
                    <h5 className="float-right text-green-600 font-medium">
                      {verifiedLookupUsername}
                    </h5>
                  )}
                </div>
              );
            })}
          </div>
        )}

        <CustomInput
          inputType="password"
          inputName="password"
          label={formatLabel("password")}
          value={formData.password}
          onChange={handleChange}
          placeholder="Password"
          required
          className={`input-field ${
            lockedFields.includes("password")
              ? "bg-gray-100 cursor-not-allowed"
              : ""
          }`}
          readOnly={lockedFields.includes("password")}
        />

        <CustomInput
          inputType="number"
          inputName="transaction_pin"
          label={formatLabel("transaction_pin")}
          value={formData.transaction_pin}
          onChange={handleChange}
          placeholder="Transaction Pin"
          className={`input-field ${
            lockedFields.includes("transaction_pin")
              ? "bg-gray-100 cursor-not-allowed"
              : ""
          }`}
          readOnly={lockedFields.includes("transaction_pin")}
        />
      </div>

      {errorResponse && (
        <div className="p-3 bg-red-100 border border-red-300 rounded-lg text-red-700">
          {errorResponse}
        </div>
      )}

      {/* Display errors */}
      {signupErrors.length > 0 && (
        <div className="mt-4 p-3 bg-red-400 rounded-lg">
          <ul className="list-disc list-outside pl-5 text-white space-y-1">
            {signupErrors.map((err, i) => (
              <li key={i} className="text-sm leading-relaxed">
                {err}
              </li>
            ))}
          </ul>
        </div>
      )}

      {successful && (
        <div className="p-3 bg-green-100 border border-green-300 rounded-lg text-green-700">
          {successful}
        </div>
      )}

      <CustomButton
        isLoading={signupLoading || signupWithoutKycLoading}
        label={"Complete Registration"}
        customLoadingMessage="Registering..."
        onPress={() => {}}
      />
    </form>
  );

  return (
    <div
      className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center p-4"
      style={{ flexDirection: "column" }}
    >
      {data && (
        <div className="w-full max-w-lg animate-slide-down">
          <LogoHeader
            organizationName={data.data.short_name}
            organizationDescription={data.data.description}
            imageLogo={
              data.data.customized_app_settings["customized-app-icon-url"]
            }
          />
        </div>
      )}
      <div className="w-full max-w-lg fintech-card p-8 animate-slide-up">
        {step === "choose" && renderChooseStep()}
        {step === "kycMethod" && renderKycMethodStep()}
        {step === "form" && renderFormStep()}
      </div>
    </div>
  );
}
